<script>
    import { t } from "../../../../i18n";

    export let data = {};

    let rows = data.itinerary||[];
</script>




{#if rows.length}
<section id="collapsible">
    <div class="collapsible">

        <style>
            .collapse-title.detailed-itinerary{display:flex;justify-content: flex-start;align-items: center;}
            .collapse-title.detailed-itinerary>div{font-size:0.9em;}
        </style>

        {#each rows as row,k}
            <div class="card collapse-header">
                <div id="headingCollapse{k}" class="card-header" data-toggle="collapse" role="button" data-target="#collapse{k}" aria-expanded="false" aria-controls="collapse{k}">
                                                        <span class="collapse-title detailed-itinerary">
                                                            <div style="width:100px;">{$t('common.day_n', {n: row.num})}</div>
                                                            <div>{row.cities}</div>

                                                        </span>
                </div>
                <div id="collapse{k}" role="tabpanel" aria-labelledby="headingCollapse{k}" class="collapse">
                    <div class="card-content">
                        <div class="card-body" style="padding:21px;">
                            {@html row.desc}
                        </div>
                    </div>
                </div>
            </div>
        {/each}


    </div>
</section>

{:else}
    {$t('common.no_data')}
{/if}